import { motion } from 'framer-motion';

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="py-32 px-6 lg:px-10 bg-[#0A1628] relative overflow-hidden"
    >
      {/* Decorative blob */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none"
        style={{
          background: 'radial-gradient(circle, rgba(0,212,184,0.10) 0%, transparent 70%)',
          filter: 'blur(80px)',
        }}
      />

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-[#FAFAF7] leading-tight mb-6">
            See the math on
            <br />
            <span className="font-bold">your numbers</span>
          </h2>
          <p className="text-base md:text-xl text-[#FAFAF7]/55 leading-relaxed max-w-xl mx-auto mb-12">
            Book a 15 minute call. We'll calculate exactly how much revenue Althera Group could save you
            each month.
          </p>
          <a
            href="#book"
            data-testid="final-cta-button"
            className="inline-block bg-[#00D4B8] text-[#0A1628] font-bold text-lg px-12 py-5 rounded-2xl hover:scale-[1.04] hover:bg-[#00D4B8]/90 transition-all duration-200 shadow-[0_8px_40px_rgba(0,212,184,0.35)]"
          >
            Book my call now
          </a>
        </motion.div>
      </div>
    </section>
  );
}
